import { prop, Vue } from 'vue-class-component';
import '@/styles/slider.scss';
import { Inject } from 'vue-property-decorator';
import type { VueI18n } from 'vue-i18n';
import { Button, ButtonTypes } from '@/components/button';
import clsx from 'clsx';
import { ServiceContainer } from '@/services';
import { AMPLITUDE_LABELS } from '@/common/constants';
import styles from './styles.module.scss';

class CreditAppLauncherProps {
	active = prop<boolean>({ default: false })

	softPullLink = prop<string>({ default: undefined })

	creditApplicationLink = prop<string>({ default: undefined })

	onHideOverlay = prop<Function>({ default: () => () => undefined })

	isCbcEnabled = prop<number>({ default: 0 })

	lenderSocketEnabled = prop<boolean>({ default: false })
}

export class CreditAppLauncher extends Vue.with(CreditAppLauncherProps) {
	@Inject() readonly i18n!: VueI18n;

	@Inject() readonly services!: ServiceContainer;

	get classes() {
		if (this.active) {
			return clsx([
				styles.creditApp, styles.creditAppActive,
			]);
		}

		return clsx([
			styles.creditApp,
		]);
	}

	triggerEvent(action: string) {
		const eventData = {
			Label: AMPLITUDE_LABELS.customizeDeal,
			Action: action,
			...this.$route.meta,
		};

		this.services.amplitude.sendEvent(eventData);
	}

	render() {
		return (
			<div class="precise-price-app__container">
				<div class={ this.classes } onClick={ this.onHideOverlay }>
					<div class={ styles.creditAppContentWrapper }>
						<div class={ styles.creditAppContent }>
							<div class={ clsx([styles.creditAppButtonWrapper, 'soft-pull-btn']) } v-show={ this.isCbcEnabled }>
								<Button
									to={ this.softPullLink }
									type={ ButtonTypes.primary }
									onClick={ () => { this.triggerEvent('SoftPull'); } }
									inverted inline fullWidth>
									{ this.i18n.t('lenderDecisioning.appSelector.softPull') }
								</Button>
								<div class={ styles.creditAppDescription }>
									{ this.i18n.t('lenderDecisioning.appSelector.softPullDescription') }
								</div>
							</div>
							<div class={ clsx([styles.creditAppButtonWrapper, 'credit-app-btn']) } v-show={ this.lenderSocketEnabled }>
								<Button
									to={ this.creditApplicationLink }
									type={ ButtonTypes.primary }
									onClick={ () => { this.triggerEvent('Apply'); } }
									inverted inline fullWidth>
									{ this.i18n.t('lenderDecisioning.appSelector.apply') }
								</Button>
								<div class={ styles.creditAppDescription }>
									{ this.i18n.t('lenderDecisioning.appSelector.applyDescription') }
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
